module.exports = __webpack_public_path__ + "static/media/header_cont_1.6fbabdc7.png";